import { useMemo } from 'react';

import usePagination from '@/hooks/usePagination';
import { Maybe, SortType, TagsFilters, TagUnion } from '@/types/schema';

import { useTagsQuery } from '../../graphql/generated/tags';

function useTags({
  filters,
  sort,
  first,
  pause = false,
  excludeIds,
  pageSize,
}: {
  filters: TagsFilters;
  sort?: Maybe<SortType[]>;
  first?: number;
  pause?: boolean;
  excludeIds?: string[];
  pageSize?: number;
}) {
  const { data, isFetching, isFetchingMore, error, refetch, fetchMore, isLoading, totalCount } =
    usePagination(
      useTagsQuery,
      {
        filters,
        sort,
        first,
      },
      { edgeKey: 'tags', requestPolicy: 'cache-and-network', pause, pageSize },
    );

  const tags = useMemo(
    // TODO @HimanshuSahu31 refactor explicit typecast
    () => data.filter((tag) => !excludeIds?.includes(tag.id)) as TagUnion[],
    [data, excludeIds],
  );

  return {
    isLoading,
    isFetching,
    isFetchingMore,
    error,
    tags,
    totalCount,
    refetch,
    fetchMore,
  };
}

export default useTags;
